import axios from 'axios'
import qs from 'qs'
import { ENDPOINTS } from '@/config/endpoints'
import { parseArrayDebtResponse } from '@/utils/formatters'

// Build form payload for Leadspedia
function buildFormPayload(dataObj) {
  // Clone and clean the data object
  const clean = { ...dataObj }

  // Remove any undefined or null values
  Object.keys(clean).forEach(key => {
    if (clean[key] === undefined || clean[key] === null) {
      delete clean[key]
    }
  })

  return clean
}

// Post lead to Leadspedia
export async function postLead(dataObj, attemptNumber) {
  const clean = buildFormPayload(dataObj)
  const postData = qs.stringify(clean)

  console.log('Lead post attempt:', attemptNumber, {
    lp_campaign_id: clean.lp_campaign_id,
    aff_id: clean.aff_id,
    array_credit: clean.array_credit,
    verified_debt: clean.verified_debt
  })

  const resp = await axios({
    method: 'post',
    maxBodyLength: Infinity,
    url: ENDPOINTS.LEAD_POST,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: postData,
  })

  console.log('Lead post response:', {
    attempt: attemptNumber,
    status: resp?.status,
    result: resp?.data?.result,
    msg: resp?.data?.msg,
    price: resp?.data?.price,
    lead_id: resp?.data?.lead_id
  })

  return resp
}

// Build base lead data object from form and session data
export function buildLeadData({
  formStore,
  sessionStore,
  campaignKeys,
  arrayData,
  variantId
}) {
  const { verified_debt } = parseArrayDebtResponse(arrayData.total_unsecured_debt)

  // Get tokens from DOM
  const jornayaToken = document.getElementById('leadid_token')?.value || ''
  const trustedFormToken = document.getElementsByName('xxTrustedFormToken')[0]?.value || ''

  return {
    ...sessionStore.formData,
    lp_campaign_id: campaignKeys.lp_campaign_id,
    lp_campaign_key: campaignKeys.lp_campaign_key,
    pd_company_id: campaignKeys.pd_company_id,
    address: formStore.address.address,
    zip_code: formStore.address.zip || sessionStore.backupZip,
    city: formStore.address.city || sessionStore.backupCity,
    state: formStore.address.state || sessionStore.backupState,
    email_address: formStore.email.value,
    first_name: formStore.name.first,
    last_name: formStore.name.last,
    phone_home: formStore.phone.unmasked,
    dob: `${formStore.dob.month}/${formStore.dob.day}/${formStore.dob.year}`,
    income: formStore.values.income,
    employed: formStore.values.employed,
    debt_amount: formStore.amountNumberValue,
    jornaya_lead_id: jornayaToken,
    trusted_form_id: trustedFormToken,
    array_collections: arrayData.collections,
    array_credit: arrayData.credit_score,
    array_delinquencies: arrayData.delinquencies,
    array_debt: arrayData.total_unsecured_debt,
    array_tax_liens: arrayData.tax_liens,
    array_student_loans: arrayData.open_student_loan_bal,
    verified_debt,
    description: formStore.values.description || '',
    assets: formStore.values.assets || '$50-$500k',
    own_real_estate: formStore.values.realEstate || false,
    split_test_variant: variantId,
    adr_fcra_disclosure: sessionStore.showArrayDisclaimer ? 'Yes' : 'No',
    tcpaLanguage: formStore.phone.tcpaLanguage || '',
    validationStatus: formStore.phone.validationStatus || 'verified'
  }
}

// Check if lead response is a duplicate
export function isDuplicateLead(response) {
  const msg = response?.data?.msg

  if (msg === 'Lead Rejected' && Array.isArray(response?.data?.errors)) {
    return response.data.errors.some((e) =>
      typeof e?.error === 'string' && e.error.toLowerCase().includes('duplicate')
    )
  }

  return false
}

// Get advertiser ID from response clients
export function getAdvertiserFromClients(clients) {
  if (!clients || !Array.isArray(clients)) return null

  for (let i = 0; i < clients.length; i++) {
    if (clients[i]?.client?.success === 'true') {
      return String(clients[i].client.advertiserID)
    }
  }

  return null
}

// Process lead submission
export async function processLead({
  dataObj,
  attemptNumber,
  formStore,
  onAttemptIncrement
}) {
  // Post the lead
  const response = await postLead(dataObj, attemptNumber)
  const duplicate = isDuplicateLead(response)

  // Check for duplicate
  if (duplicate) {
    console.warn('Lead rejected due to duplicate:', dataObj.email_address)
    return { response, dataObj, duplicate: true }
  }

  return { response, dataObj, duplicate: false }
}

export const leadService = {
  postLead,
  buildLeadData,
  isDuplicateLead,
  getAdvertiserFromClients,
  processLead
}
